import { render, staticRenderFns } from "./FacturarForm.vue?vue&type=template&id=36256933"
import script from "./FacturarForm.vue?vue&type=script&lang=js"
export * from "./FacturarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports